import Swal from 'sweetalert2'
import Autenticacao from '@/services/Autenticacao'
import RegisterForm from '@/components/Dashboard/Views/Forms/ValidationForms/RegisterForm'

const controller = {
  name: 'RegisterCtrl',
  components: {
    RegisterForm
  },
  data () {
    return {
      fullscreenLoading: false,
      nome: '',
      email: '',
      contato: {
        celular: ''
      },
      senha: '',
      confirmacaoSenha: ''
    }
  },
  methods: {
    toggleNavbar () {
      document.body.classList.toggle('nav-open')
    },
    closeMenu () {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    },
    informUserAboutValidation (email, celular) {
      Autenticacao.enviarEmailVerificacaoAndRegisterBackEnd(celular)
        .then(() => {
          this.fullscreenLoading = false
          Swal(
            'Validação de email!',
            `Favor checar seu e-mail ${email} e clicar no link para validação da sua conta!`,
            'success'
          )
          .then(pressedOk => {
            if (pressedOk) {
              Autenticacao.sair()
                .then(() => {
                  this.$router.push({
                    name: 'entrar'
                  })
                })
            }
          })
        })
    },
    onRegisterSubmit (model, isValid) {
      if (isValid) {
        this.fullscreenLoading = true
        Autenticacao.registrar(model.nome, model.email, model.password)
          .then(() => this.informUserAboutValidation(model.email, model.contato.celular))
          .catch(() => {
            Autenticacao.sair()
            this.fullscreenLoading = false
            Swal(
              'Erro no registro!',
              `Houve um problema ao registrar ${model.email}, favor entrar em contato com o suporte!`,
              'error'
            )
          })
      }
    }
  },
  beforeDestroy () {
    this.closeMenu()
  }
}

export default controller



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Pages/RegisterCtrl.js